import { useStore } from "@stores";
import { observer } from "mobx-react";
import { Navigate, Outlet } from "react-router-dom";

declare const abp: any;

export const ProtectedRoute = observer(() => {
  const { authStore } = useStore();
  const hasSession = !!authStore.currentUserId;
  const hasToken = !!abp.auth.getToken();

  if (!hasSession || !hasToken) {
    if (hasSession && !hasToken) {
      localStorage.clear();
      sessionStorage.clear();
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
});
